export const ThinChevronRight = ({fillColor = '#212124', width = 16, height = 16}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <path
        fill={fillColor}
        d="m11.354 8.354-5 5a.5.5 0 1 1-.707-.708L10.293 8 5.647 3.354a.5.5 0 1 1 .707-.708l5 5a.5.5 0 0 1 0 .708Z"
      />
    </svg>
  );
};
